export default {
  articles: {
    /** null | 'first' (carga inicial/refiltro) | 'more' (scroll infinito) */
    loading: null,
    data: [],
    /** Cursor opaco da próxima página; null quando acabou. */
    nextCursor: null,
    hasMore: false,
    error: false,
    lastUpdate: null,
  },
  /** Catálogo de fontes para os chips do filtro. */
  sources: [],
  filtros: {
    /** Slugs selecionados; vazio = todas as fontes. */
    sources: [],
    termo: '',
  },
}
